import { createRequest } from "./createRequest.js";
import { Method } from "./types.js";
export function createHttpClient(options = {}) {
  const baseUrl = options.baseUrl ?? null;
  const fetchImpl = options.fetch ?? fetch;
  function resolveUrl(url) {
    if (baseUrl) {
      return new URL(url, baseUrl).toString();
    }
    return url;
  }
  return {
    get(url, {
      headers,
      query
    } = {}) {
      return createRequest(fetchImpl, resolveUrl(url), {
        headers,
        method: Method.GET,
        query
      });
    },
    post(url, {
      headers,
      payload,
      query
    } = {}) {
      return createRequest(fetchImpl, resolveUrl(url), {
        headers,
        method: Method.POST,
        payload,
        query
      });
    },
    put(url, {
      headers,
      payload,
      query
    } = {}) {
      return createRequest(fetchImpl, resolveUrl(url), {
        headers,
        method: Method.PUT,
        payload,
        query
      });
    },
    patch(url, {
      headers,
      payload,
      query
    } = {}) {
      return createRequest(fetchImpl, resolveUrl(url), {
        headers,
        method: Method.PATCH,
        payload,
        query
      });
    },
    delete(url, {
      headers,
      payload,
      query
    } = {}) {
      return createRequest(fetchImpl, resolveUrl(url), {
        headers,
        method: Method.DELETE,
        payload,
        query
      });
    }
  };
}